// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login-page precisa ocupar a tela inteira, sem o max-width/padding
   que .app-content aplica ao conteúdo autenticado */
.app-content:has(> .login-page) {
  max-width: none;
  margin: 0;
  padding: 0;
}

.login-page {
  position: relative;
  min-height: 100vh;
  background: var(--ink, #15140F);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}
.login-side-grid {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(240,236,224,.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(240,236,224,.05) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 100%);
}

.login-card {
  position: relative; z-index: 1;
  width: 100%;
  max-width: 380px;
  background: #1B1A16;
  border: 1px solid #3A3728;
  border-radius: 20px;
  padding: 40px 36px;
  box-shadow: 0 1px 2px rgba(0,0,0,.3), 0 30px 60px -24px rgba(0,0,0,.6);
  margin: 24px;
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 28px;
}
.login-brand span {
  font-family: 'Oswald', sans-serif;
  font-weight: 600;
  font-size: 19px;
  letter-spacing: .02em;
  text-transform: uppercase;
  color: #F0ECE0;
}

.login-card h1 {
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  font-size: 22px;
  color: #F0ECE0;
  margin-bottom: 28px;
  line-height: 1.15;
}

.login-form { display: flex; flex-direction: column; gap: 16px; }
.login-field { display: flex; flex-direction: column; gap: 6px; }
.login-field label {
  font-size: 12px; font-weight: 600; color: #A9A794;
  text-transform: uppercase; letter-spacing: .04em;
}
.login-input-group { position: relative; display: flex; align-items: center; }
.login-input-group svg {
  position: absolute; left: 14px; width: 16px; height: 16px;
  color: #6B6858; pointer-events: none;
}
.login-field input {
  width: 100%;
  padding: 13px 14px 13px 40px;
  border: 1px solid #3A3728;
  border-radius: 10px;
  font-size: 14.5px;
  font-family: 'Inter', sans-serif;
  background: #232019;
  color: #F0ECE0;
  transition: border-color .15s, box-shadow .15s;
}
.login-field input::placeholder { color: #6B6858; }
.login-field input:focus {
  outline: none;
  border-color: var(--cobalt, #1F4FD8);
  box-shadow: 0 0 0 3px rgba(31,79,216,.25);
}
.login-toggle-senha {
  position: absolute; right: 6px; width: 30px; height: 30px; display: flex;
  align-items: center; justify-content: center; background: none; border: none;
  color: #6B6858; cursor: pointer; border-radius: 8px;
}
.login-toggle-senha:hover { background: rgba(240,236,224,.06); color: #F0ECE0; }
.login-toggle-senha svg { width: 17px; height: 17px; }

.login-erro {
  background: rgba(179,58,46,.14);
  color: #E38070;
  padding: 11px 14px;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 500;
}

.login-btn {
  display: flex; align-items: center; justify-content: center; gap: 8px;
  background: var(--cobalt, #1F4FD8);
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 10px;
  font-size: 14.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s, transform .15s;
  margin-top: 6px;
}
.login-btn:hover:not(:disabled) { background: var(--cobalt-dark, #123499); transform: translateY(-1px); }
.login-btn:active:not(:disabled) { transform: translateY(0); }
.login-btn:disabled { opacity: .7; cursor: not-allowed; }
.login-spinner {
  width: 15px; height: 15px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,.4); border-top-color: #fff;
  animation: login-spin .7s linear infinite;
}
@keyframes login-spin { to { transform: rotate(360deg); } }

.login-footnote {
  margin-top: 28px;
  font-size: 12px;
  color: #6B6858;
  text-align: center;
}

@media (max-width: 480px) {
  .login-card { padding: 32px 24px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;oDACoD;AACpD;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB,EAAE,QAAQ;EAC5B;;sEAEoE;EACpE,0BAA0B;EAC1B,mFAAmF;AACrF;;AAEA;EACE,kBAAkB,EAAE,UAAU;EAC9B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sEAAsE;EACtE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,cAAc,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAChE,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,yBAAyB,EAAE,qBAAqB;AAClD;AACA,qBAAqB,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC7E;EACE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY;EACzD,cAAc,EAAE,oBAAoB;AACtC;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA,kCAAkC,cAAc,EAAE;AAClD;EACE,aAAa;EACb,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa;EACxE,mBAAmB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,YAAY;EAC5E,cAAc,EAAE,eAAe,EAAE,kBAAkB;AACrD;AACA,4BAA4B,iCAAiC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EACrE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,eAAe;AACjB;AACA,kCAAkC,uCAAuC,EAAE,2BAA2B,EAAE;AACxG,mCAAmC,wBAAwB,EAAE;AAC7D,sBAAsB,WAAW,EAAE,mBAAmB,EAAE;AACxD;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,sCAAsC,EAAE,sBAAsB;EAC9D,yCAAyC;AAC3C;AACA,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;;AAE1D;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc,kBAAkB,EAAE;AACpC","sourcesContent":["/* login-page precisa ocupar a tela inteira, sem o max-width/padding\n   que .app-content aplica ao conteúdo autenticado */\n.app-content:has(> .login-page) {\n  max-width: none;\n  margin: 0;\n  padding: 0;\n}\n\n.login-page {\n  position: relative;\n  min-height: 100vh;\n  background: var(--ink, #15140F);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Inter', sans-serif;\n  overflow: hidden;\n}\n.login-side-grid {\n  position: absolute; inset: 0;\n  background-image:\n    linear-gradient(rgba(240,236,224,.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(240,236,224,.05) 1px, transparent 1px);\n  background-size: 42px 42px;\n  mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 100%);\n}\n\n.login-card {\n  position: relative; z-index: 1;\n  width: 100%;\n  max-width: 380px;\n  background: #1B1A16;\n  border: 1px solid #3A3728;\n  border-radius: 20px;\n  padding: 40px 36px;\n  box-shadow: 0 1px 2px rgba(0,0,0,.3), 0 30px 60px -24px rgba(0,0,0,.6);\n  margin: 24px;\n}\n\n.login-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 28px;\n}\n.login-brand span {\n  font-family: 'Oswald', sans-serif;\n  font-weight: 600;\n  font-size: 19px;\n  letter-spacing: .02em;\n  text-transform: uppercase;\n  color: #F0ECE0;\n}\n\n.login-card h1 {\n  font-family: 'Oswald', sans-serif;\n  text-transform: uppercase;\n  font-size: 22px;\n  color: #F0ECE0;\n  margin-bottom: 28px;\n  line-height: 1.15;\n}\n\n.login-form { display: flex; flex-direction: column; gap: 16px; }\n.login-field { display: flex; flex-direction: column; gap: 6px; }\n.login-field label {\n  font-size: 12px; font-weight: 600; color: #A9A794;\n  text-transform: uppercase; letter-spacing: .04em;\n}\n.login-input-group { position: relative; display: flex; align-items: center; }\n.login-input-group svg {\n  position: absolute; left: 14px; width: 16px; height: 16px;\n  color: #6B6858; pointer-events: none;\n}\n.login-field input {\n  width: 100%;\n  padding: 13px 14px 13px 40px;\n  border: 1px solid #3A3728;\n  border-radius: 10px;\n  font-size: 14.5px;\n  font-family: 'Inter', sans-serif;\n  background: #232019;\n  color: #F0ECE0;\n  transition: border-color .15s, box-shadow .15s;\n}\n.login-field input::placeholder { color: #6B6858; }\n.login-field input:focus {\n  outline: none;\n  border-color: var(--cobalt, #1F4FD8);\n  box-shadow: 0 0 0 3px rgba(31,79,216,.25);\n}\n.login-toggle-senha {\n  position: absolute; right: 6px; width: 30px; height: 30px; display: flex;\n  align-items: center; justify-content: center; background: none; border: none;\n  color: #6B6858; cursor: pointer; border-radius: 8px;\n}\n.login-toggle-senha:hover { background: rgba(240,236,224,.06); color: #F0ECE0; }\n.login-toggle-senha svg { width: 17px; height: 17px; }\n\n.login-erro {\n  background: rgba(179,58,46,.14);\n  color: #E38070;\n  padding: 11px 14px;\n  border-radius: 10px;\n  font-size: 13.5px;\n  font-weight: 500;\n}\n\n.login-btn {\n  display: flex; align-items: center; justify-content: center; gap: 8px;\n  background: var(--cobalt, #1F4FD8);\n  color: #fff;\n  border: none;\n  padding: 15px;\n  border-radius: 10px;\n  font-size: 14.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background .15s, transform .15s;\n  margin-top: 6px;\n}\n.login-btn:hover:not(:disabled) { background: var(--cobalt-dark, #123499); transform: translateY(-1px); }\n.login-btn:active:not(:disabled) { transform: translateY(0); }\n.login-btn:disabled { opacity: .7; cursor: not-allowed; }\n.login-spinner {\n  width: 15px; height: 15px; border-radius: 50%;\n  border: 2px solid rgba(255,255,255,.4); border-top-color: #fff;\n  animation: login-spin .7s linear infinite;\n}\n@keyframes login-spin { to { transform: rotate(360deg); } }\n\n.login-footnote {\n  margin-top: 28px;\n  font-size: 12px;\n  color: #6B6858;\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .login-card { padding: 32px 24px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
